var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBenzingaAi = function SvgBenzingaAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    rx: 3.38528,
    fill: "#9EA6B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2898 11L10.3753 9.0375H7.99798L7.30045 11H4.58153L8.23998 2H12.9376L12.9945 11H10.2898ZM9.7062 4.1875L8.58162 7.3625H10.4464L10.603 4.1875H9.7062Z",
    fill: "url(#paint0_linear_1003_328)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2898 11L10.3753 9.0375H7.99798L7.30045 11H4.58153L8.23998 2H12.9376L12.9945 11H10.2898ZM9.7062 4.1875L8.58162 7.3625H10.4464L10.603 4.1875H9.7062Z",
    fill: "#28313C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2L16.2064 11H13.6298L15.4377 2H18Z",
    fill: "url(#paint1_linear_1003_328)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2L16.2064 11H13.6298L15.4377 2H18Z",
    fill: "#28313C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17567 2.4238C4.07784 2.37023 3.96486 2.34183 3.84958 2.34183C3.72092 2.34176 3.59547 2.37705 3.49081 2.44275C3.38616 2.50845 3.30754 2.60126 3.26598 2.70818L3.05029 3.26393L2.41802 3.45332L2.3453 3.4793C2.2357 3.52641 2.1445 3.60103 2.08326 3.6937C2.02201 3.78638 1.99347 3.89293 2.00126 3.99986C2.00905 4.10679 2.05281 4.20928 2.127 4.29435C2.2012 4.37941 2.30248 4.44322 2.41802 4.47769L3.05091 4.66709L3.2666 5.2223L3.29618 5.28561C3.34978 5.38186 3.43471 5.46197 3.54021 5.5158C3.6457 5.56962 3.76703 5.59473 3.88879 5.58795C4.01056 5.58117 4.1273 5.5428 4.22421 5.47771C4.32112 5.41261 4.39385 5.32372 4.43317 5.2223L4.64886 4.66655L5.28114 4.47715L5.35385 4.45118C5.46345 4.40407 5.55465 4.32944 5.6159 4.23677C5.67715 4.1441 5.70568 4.03755 5.69789 3.93062C5.69011 3.82369 5.64634 3.72119 5.57215 3.63613C5.49796 3.55106 5.39667 3.48725 5.28114 3.45278L4.64824 3.26338L4.43255 2.70818L4.40297 2.64487C4.35225 2.55396 4.27349 2.47737 4.17567 2.4238Z",
    fill: "url(#paint2_linear_1003_328)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17567 2.4238C4.07784 2.37023 3.96486 2.34183 3.84958 2.34183C3.72092 2.34176 3.59547 2.37705 3.49081 2.44275C3.38616 2.50845 3.30754 2.60126 3.26598 2.70818L3.05029 3.26393L2.41802 3.45332L2.3453 3.4793C2.2357 3.52641 2.1445 3.60103 2.08326 3.6937C2.02201 3.78638 1.99347 3.89293 2.00126 3.99986C2.00905 4.10679 2.05281 4.20928 2.127 4.29435C2.2012 4.37941 2.30248 4.44322 2.41802 4.47769L3.05091 4.66709L3.2666 5.2223L3.29618 5.28561C3.34978 5.38186 3.43471 5.46197 3.54021 5.5158C3.6457 5.56962 3.76703 5.59473 3.88879 5.58795C4.01056 5.58117 4.1273 5.5428 4.22421 5.47771C4.32112 5.41261 4.39385 5.32372 4.43317 5.2223L4.64886 4.66655L5.28114 4.47715L5.35385 4.45118C5.46345 4.40407 5.55465 4.32944 5.6159 4.23677C5.67715 4.1441 5.70568 4.03755 5.69789 3.93062C5.69011 3.82369 5.64634 3.72119 5.57215 3.63613C5.49796 3.55106 5.39667 3.48725 5.28114 3.45278L4.64824 3.26338L4.43255 2.70818L4.40297 2.64487C4.35225 2.55396 4.27349 2.47737 4.17567 2.4238Z",
    fill: "#28313C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16V14H7L4 16Z",
    fill: "#9EA6B1",
    stroke: "#9EA6B1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1003_328",
    x1: 10,
    y1: 2,
    x2: 10,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC12A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D99C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1003_328",
    x1: 10,
    y1: 2,
    x2: 10,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC12A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D99C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1003_328",
    x1: 10,
    y1: 2,
    x2: 10,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC12A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D99C8"
  })))));
};
export { SvgBenzingaAi as ReactComponent };